import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import useTheme from '@material-ui/core/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { AddButton } from '../../../../components/addButton';
import CreateItem from './create';
import SelectSource, { ISelectItem } from './select';

const NewItem: React.FC = () => {
    const theme = useTheme();
    const fullScreen = useMediaQuery( theme.breakpoints.down( 'sm' ) );
    const [open, setOpen] = useState( false );
    const [create, setCreate] = useState( false );
    const [selection, setSelection] = useState<ISelectItem | undefined>( undefined );

    const handleClose = () => {
        setOpen( false );
        setCreate(false);
        setSelection(undefined);
    };

    const handleSelect = (copyStrain?: ISelectItem) => {
        setCreate(true);
        setSelection(copyStrain);
    };

    return (
        <>
            <AddButton onClick={() => setOpen( true )}/>

            <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Create New Item</DialogTitle>
                {create ? (
                    <CreateItem
                        selection={selection}
                        onClose={handleClose}
                        onBack={() => setCreate(false)}
                    />
                ) : (
                  <SelectSource
                    onClose={handleClose}
                    onSelect={handleSelect}
                  />
                )}
            </Dialog>
        </>
    );
};

export default NewItem;